import { isOverRect } from "@/canv/utils";
import { CardWidgetStatusBarCheckBox } from "./checkbox";
import { CardWidgetStatusBarStatus } from "./status";
import type { AdvancedCardProgressDataItem } from "./types";

export class CardWidgetStatusBar {
    constructor(startX: number, startY: number) {
        this.startX = startX;
        this.startY = startY;
        this.height = 33;

        this.checkbox = new CardWidgetStatusBarCheckBox(0, 0, this.height, this.height);
        this.status = new CardWidgetStatusBarStatus(0, 0, this.height);
    }

    updateCoords(startX: number, startY: number) {
        this.startX = startX;
        this.startY = startY;
        this.updateDims();
    }

    updateDims() {
        this.checkbox.updateCoords(this.startX, this.startY);

        const checkboxAndStatusGap = 15;
        this.status.updateCoords(
            this.checkbox.startX + this.checkbox.width + checkboxAndStatusGap,
            this.startY,
        );

        this.width = this.checkbox.width + checkboxAndStatusGap + this.status.width + this.height; // this.height - это попытка учесть ширину drawPoints. Просто дополнительный гэп
    }

    isStatusClick() {
        if (
            isOverRect(
                this.status.startX,
                this.status.startY,
                this.status.width,
                this.status.height,
            )
        ) {
            return true;
        }

        return false;
    }

    isCheckboxClick() {
        if (
            isOverRect(
                this.checkbox.startX,
                this.checkbox.startY,
                this.checkbox.width,
                this.checkbox.height,
            )
        ) {
            return true;
        }

        return false;
    }

    setProgressData(progressData: AdvancedCardProgressDataItem, smooth = true) {
        this.checkbox.setIsChecked(progressData.name === "done");
        this.status.setProgressData(progressData, smooth);
    }

    draw() {
        this.checkbox.draw();
        this.status.draw();
    }

    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    checkbox: CardWidgetStatusBarCheckBox;
    status: CardWidgetStatusBarStatus;
}
